
export default {
  defaultCredentials: {
    username: 'administrator@citadel.tools',
    password: 'password',
  },
  apiPath: 'http://localhost:4007/api/v1',
};
